import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { AUDIT_REASON_API_URL, EVALUATION_ADJUSTMENT_API_URL, EVALUATIONS_API_URL, MEDICAL_RECORDS_API_URL, PAYMENT_INTEGRITY, PI_EVALUATION_DETAILS, QUICK_FILTER_API_URL, OVERTURNS_API_URL } from './apiUrlConstants';
import { returnParamsValuesforPI } from '@src/utility/commonUtilityServices';


const _httpService = new HttpService();
const cache = new Map();
const evaluationDetailsRequests = new Map<string, Promise<unknown>>();

if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else{
 _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
 //_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}

export const getEvaluationData= async (data:any) =>{
   const url=EVALUATIONS_API_URL;
    try {
      const payload:any = returnParamsValuesforPI(data);
      if (!payload || Object.keys(payload).length === 0 ||
          (!payload.ProviderSysKey && (!payload.Tin || payload.Tin === null) && !payload.Region && !payload.ContractIds?.length)) {
        return null;
      }

      const responseData: any = await _httpService.push(url, payload);
      return responseData;
    } catch (error) {
      console.error('Error fetching evaluation data:', error);
      return null;
    }
  }

  export const getMedicalRecordData = async (data: any) => {
    try {
      const payload: any = returnParamsValuesforPI(data);
      if (!payload || Object.keys(payload).length === 0 ||
          (!payload.ProviderSysKey && (!payload.Tin || payload.Tin === null) && !payload.Region && !payload.ContractIds?.length)) {
        return null;
      }

      const responseData: any = await _httpService.push(MEDICAL_RECORDS_API_URL, payload);
      return responseData;
    } catch (error) {
      console.error('Error fetching medical records data:', error);
      return null;
    }
  }
  export const getPaymentIntegrityQuickFilters = async (payload: any) => {
    try {
      const response = await _httpService.push(QUICK_FILTER_API_URL, payload);
      return response;
    } catch (error) {
      console.error('Payment Integrity Quick Filters API call failed:', error);
      return null;
    }
  };

  export const getQuickFiltersTinList = async () => {
    try {
      const endpoint = sessionStorage.getItem('multiTinNavigation')
        ? '/extended-tins/top-filter?items=MULTITIN'
        : '/standard-search/topfilter';
      const payload = sessionStorage.getItem('multiTinNavigation')
        ? { Tin: sessionStorage.getItem('multiSelectedTins') }
        : {
            ProviderSysKey:
              JSON.parse(
                sessionStorage.getItem('providerInfo') ?? '{"ProviderSysKey": ""}'
              )?.ProviderSysKey ?? '',
          };
      const response = await _httpService.push(endpoint, {
        RequestedJourney: 'provTinListFilter',
        ProvTinListFilter: payload,
      });
      return response;
    } catch (error) {
      console.error('Quick filter API call failed:', error);
      return null;
    }
  };

  export const getEvaluationAdjustmentData= async (data:any) =>{
    try {
      const payload:any = returnParamsValuesforPI(data);
      if (!payload || Object.keys(payload).length === 0 ||
          (!payload.ProviderSysKey && (!payload.Tin || payload.Tin === null) && !payload.Region && !payload.ContractIds?.length)) {
        return null;
      }

      const responseData: any = await _httpService.push(EVALUATION_ADJUSTMENT_API_URL, payload);
      return responseData;
    } catch (error) {
      console.error('Error fetching evaluation adjustment data:', error);
      return null;
    }
  }

  export const getOverturnsData = async (data: any) => {
    try {
      const payload: any = returnParamsValuesforPI(data);
      if (!payload || Object.keys(payload).length === 0 ||
          (!payload.ProviderSysKey && (!payload.Tin || payload.Tin === null) && !payload.Region && !payload.ContractIds?.length)) {
        return null;
      }

      const responseData: any = await _httpService.push(OVERTURNS_API_URL, payload);
      return responseData;
    } catch (error) {
      console.error('Error fetching overturns data:', error);
      return null;
    }
  }

  export const getAuditReasonData= async (data:any) =>{
    try {
      const payload:any = returnParamsValuesforPI(data);
      if (!payload || Object.keys(payload).length === 0 ||
          (!payload.ProviderSysKey && (!payload.Tin || payload.Tin === null) && !payload.Region && !payload.ContractIds?.length)) {
        return null;
      }

      const responseData: any = await _httpService.push(AUDIT_REASON_API_URL, payload);
      return responseData;
    } catch (error) {
      console.error('Error fetching audit reason data:', error);
      return null;
    }
  }

  export const getPIEvaluationDetailsdAPIData = async (data?: any, radioValue?: any) => {
    const requestKey = JSON.stringify({ data: data || {}, radioValue: radioValue || 'ANNUAL' });
    const existingRequest = evaluationDetailsRequests.get(requestKey);
    if (existingRequest) return existingRequest;

    const request = getPIEvaluationDetailsdAPIDataInternal(data, radioValue);
    evaluationDetailsRequests.set(requestKey, request);
    request.finally(() => evaluationDetailsRequests.delete(requestKey));
    return request;
  };

  const getPIEvaluationDetailsdAPIDataInternal = async (data?: any, radioValue?: any) => {
    try {
      const payload:any = returnParamsValuesforPI(data);
      delete payload['TimeFilter'];
      delete payload['TimeFilterText'];
      const validRadioValue = radioValue || 'ANNUAL';
            if (!payload || Object.keys(payload).length === 0 ||
          (!payload.ProviderSysKey && !payload.Tin && !payload.Region && !payload.ContractIds?.length)) {
        return null;
      }

      const piURL = PAYMENT_INTEGRITY + PI_EVALUATION_DETAILS + '?request-type=' + validRadioValue;
      const { TimeFilter, TimeFilterText, ...rest } = payload;
      const restPayload = rest;
      const responseData: any = await _httpService.push(piURL, restPayload);

      return responseData;
    } catch (error) {
      console.error('Error fetching evaluation details data:', error);
      return null;
    }
  };

export interface PaymentIntegrityGeoFilterPayload {
    RequestedJourney: string;
    PaymentIntegrityFilter: {
        TimeFilter: string;
        TimeFilterText: string;
        Region: string; // Single region value
        State?: string; // Optional comma(,) separated state codes: "MI,IA,OH"
        Market?: string; // Optional pipe(|) separated market names: "Market1|Market2|Market3"
    };
}

/**
 * Convert date format from MM/DD/YYYY to YYYY/MM/DD
 * @param dateStr - Date string in MM/DD/YYYY format
 * @returns Date string in YYYY/MM/DD format
 */
const convertDateFormat = (dateStr: string): string => {
    const parts = dateStr.split('/');
    if (parts.length === 3) {
        const [month, day, year] = parts;
        return `${year}/${month}/${day}`;
    }
    return dateStr;
};

/**
 * Get time filter data from session storage.
 * Reads from unified piFilterState first, falls back to piTimePeriod.
 * @returns Time filter object with appropriate format
 */
export const getTimeFilterData = () => {
    try {
        // Try unified piFilterState first
        const piFilterStr = sessionStorage.getItem('piFilterState');
        if (piFilterStr) {
            const piFilter = JSON.parse(piFilterStr);
            const tp = piFilter?.timePeriod;
            if (tp?.value) {
                if (tp.value.includes('/') && tp.value.includes('-')) {
                    const [startDate, endDate] = tp.value.split('-');
                    return {
                        TimeFilter: 'DatesSplit',
                        TimeFilterText: `${convertDateFormat(startDate.trim())}-${convertDateFormat(endDate.trim())}`
                    };
                }
                // Year format: "2024" → convert to DatesSplit "2024/01/01-2024/12/31"
                if (/^\d{4}$/.test(tp.value)) {
                    return {
                        TimeFilter: 'DatesSplit',
                        TimeFilterText: `${tp.value}/01/01-${tp.value}/12/31`
                    };
                }
                return { TimeFilter: 'DatesSplit', TimeFilterText: tp.value };
            }
        }

        // Fallback: piTimePeriod (backward compat)
        const timePeriodData = sessionStorage.getItem('piTimePeriod');
        if (timePeriodData) {
            const parsed = JSON.parse(timePeriodData);

            // If it's a date range format like "01/01/2025-10/31/2025"
            if (parsed.value && parsed.value.includes('/') && parsed.value.includes('-')) {
                const [startDate, endDate] = parsed.value.split('-');
                const formattedStartDate = convertDateFormat(startDate.trim());
                const formattedEndDate = convertDateFormat(endDate.trim());
                return {
                    TimeFilter: "DatesSplit",
                    TimeFilterText: `${formattedStartDate}-${formattedEndDate}`
                };
            }
            // If it's a year format like "2024" or "2025" → convert to DatesSplit
            else if (parsed.value) {
                if (/^\d{4}$/.test(parsed.value)) {
                    return {
                        TimeFilter: "DatesSplit",
                        TimeFilterText: `${parsed.value}/01/01-${parsed.value}/12/31`
                    };
                }
                return {
                    TimeFilter: "DatesSplit",
                    TimeFilterText: parsed.value
                };
            }
        }
    } catch (error) {
        console.error('Error reading time filter from session storage:', error);
    }

    // Default fallback to current year as DatesSplit
    const currentYear = new Date().getFullYear();
    return {
        TimeFilter: "DatesSplit",
        TimeFilterText: `${currentYear}/01/01-${currentYear}/12/31`
    };
};

/**
 * Get region value from session storage.
 * Reads from PI_GEO_SELECTED_REGION first, falls back to piDetailsPayload.
 */
export const getRegionFromSessionStorage = (): string => {
  try {
    // Try PI_GEO_SELECTED_REGION first
    const geoRegionStr = sessionStorage.getItem('PI_GEO_SELECTED_REGION');
    if (geoRegionStr) {
      const regionArr = JSON.parse(geoRegionStr);
      if (Array.isArray(regionArr) && regionArr.length > 0 && regionArr[0].value) {
        return regionArr[0].value;
      }
    }
    // Fallback: piDetailsPayload (backward compat)
    const piDetailsPayloadRaw = sessionStorage.getItem('piDetailsPayload');
    if (piDetailsPayloadRaw) {
      const piDetailsPayload: any = JSON.parse(piDetailsPayloadRaw);
      if (piDetailsPayload.Region && typeof piDetailsPayload.Region === 'string') {
        return piDetailsPayload.Region;
      }
    }
  } catch (error) {
    console.error('Error reading Region from session storage:', error);
  }
  return '';
};

/**
 * Call Payment Integrity Geo Filter API
 * @param payload - PaymentIntegrityGeoFilterPayload object
 * @returns Promise with API response
 */
export const getPaymentIntegrityGeoFilterData = async (payload: PaymentIntegrityGeoFilterPayload): Promise<any> => {
    try {
        const response = await _httpService.push(QUICK_FILTER_API_URL, payload);
        return response;
    } catch (error) {
        console.error('Payment Integrity Geo Filter API call failed:', error);
        return null;
    }
};
